import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next"
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import { Calendar } from 'primereact/calendar'
import { Divider, MenuItem, Menu } from '@mui/material'
import './dashboardV1.css'
import { useNavigate } from 'react-router-dom'
import { NavigateContext, M_CheckBox, M_Button, M_DrawerTableTextField, M_Graph, M_Select, LoadingContext, LoadingBar, BufferService, M_Header, } from 'src/M_Components'


export default function DashboardV1({ roles }) {
    const navigate = useNavigate()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    let firstDay = new Date(new Date().getFullYear(), 0, 1)
    let today = new Date()
    let month = today.getMonth()
    let year = today.getFullYear()
    let prevMonth = (month === 0) ? 11 : month - 1
    let prevYear = (prevMonth === 11) ? year - 1 : year
    let nextMonth = (month === 11) ? 0 : month + 1
    let nextYear = (nextMonth === 0) ? year + 1 : year
    let arrayDate = [firstDay, today]

    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    let minDate = new Date()
    minDate.setMonth(prevMonth)
    minDate.setFullYear(prevYear)

    let maxDate = new Date()
    maxDate.setMonth(nextMonth)
    maxDate.setFullYear(nextYear)

    //DATA DASHBOARD
    const [dataVoyages, setDataVoyages] = useState([])

    const [filtersMap, setFiltersMap] = useState(new Map())
    const [filtersDashboard, setFiltersDashboard] = useState([])

    const [dataDesdobramento, setDataDesdobramento] = useState([])

    const [checkOcupation, setCheckOcupation] = useState(false)
    const [selectAnnualView, setSelectAnnualView] = useState("Booking")

    const [rangeDate, setRangeDate] = useState(arrayDate)
    const [dateType, setDateType] = useState({ label: 'Created On', value: 'createdOn' })
    const [isLoaded, setIsLoaded] = useState(true)
    const [typeUser, setTypeUser] = useState(false)
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const bufferServiceVoyages = new BufferService('Voyage')
    const bufferServiceFilters = new BufferService('DashboardFilters/Dashboard')
    const { t } = useTranslation()

    const [showWeight, setShowWeight] = useState('Capacity')

    const sessionKeys = ['filtersMap', 'filtersDashboard', 'checkOcupation', 'selectAnnualView', 'typeUser', 'dataVoyages', 'rangeDate', 'dataDesdobramento', 'showWeight', 'dateType']


    function toJSONLocal(date) {
        var local = new Date(date);
        local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        return local.toJSON().slice(0, 10);
    }

    useEffect(() => {
        if (isFirstLoop) {
            getSessionStorageData(id)
            setIsFirstLoop(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line  
    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, filtersMap, filtersDashboard, checkOcupation, selectAnnualView, typeUser, dataVoyages, rangeDate, dataDesdobramento, showWeight, dateType])

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        const tempFM = sessionStorage.getItem(`${sessionID}filtersMap`)
        const tempFD = sessionStorage.getItem(`${sessionID}filtersDashboard`)
        const tempCO = sessionStorage.getItem(`${sessionID}checkOcupation`)
        const tempAV = sessionStorage.getItem(`${sessionID}selectAnnualView`)
        const tempTU = sessionStorage.getItem(`${sessionID}typeUser`)
        const tempDV = sessionStorage.getItem(`${sessionID}dataVoyages`)
        const tempRD = sessionStorage.getItem(`${sessionID}rangeDate`)
        const tempDD = sessionStorage.getItem(`${sessionID}dataDesdobramento`)
        const tempSW = sessionStorage.getItem(`${sessionID}showWeight`)
        const tempDT = sessionStorage.getItem(`${sessionID}dateType`)
        if (tempDV !== "undefined" && tempDV && tempDD !== "undefined" && tempDD && JSON.parse(tempDD)?.length !== 0 && (tempFM || tempFD || tempCO || tempAV || tempTU || tempDV || tempDD || tempSW || tempDT)) {
            setFiltersMap(new Map(JSON.parse(tempFM)))
            setFiltersDashboard(JSON.parse(tempFD))
            setCheckOcupation(JSON.parse(tempCO))
            setSelectAnnualView(JSON.parse(tempAV))
            setTypeUser(JSON.parse(tempTU))
            setDataVoyages(JSON.parse(tempDV))
            setDataDesdobramento(JSON.parse(tempDD))
            setRangeDate([new Date(JSON.parse(tempRD)[0]), new Date(JSON.parse(tempRD)[1])])
            setShowWeight(JSON.parse(tempSW))
            setDateType(JSON.parse(tempDT))
            setIsLoaded(false)
            return
        }
        get()
    }

    const get = () => {
        filtersMap.set('Voyage', '')
        filtersMap.set('Trade', '')
        filtersMap.set('Account', '')
        filtersMap.set('Location', '')
        filtersMap.set('StartDate', toJSONLocal(arrayDate[0]))
        filtersMap.set('EndDate', toJSONLocal(arrayDate[1]))
        filtersMap.set('DateType', "createdOn")

        setFiltersMap(new Map(filtersMap))
        submitFilters(filtersMap)

        if (roles.includes('dashboard adminList')) {
            setTypeUser(true)
        }
        else {
            setTypeUser(false)
        }

        bufferServiceVoyages.get().then((response) => {
            if (response.name === 'AxiosError') {
                setDataVoyages([])
                ctx.toastMessages('error', response.message, '')
                return
            }
            setDataVoyages(response.Items)
        })
        columnChartData('Booking', true)
    }

    const columnChartData = (type, useLoad) => {
        if (useLoad) ctx.setIsLoad(true)
        bufferServiceFilters.get().then((response) => {
            ctx.setIsLoad(false)
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.message, '')
                if (useLoad) ctx.setIsLoad(false)
                return
            }
            if (useLoad) ctx.setIsLoad(false)
            const tempArray = []
            const newData = { labels: [], datasets: [] }
            response.DUMonthlyData.forEach(element => {
                newData.labels.push(element.Month)
                if (element.Voyages.lenght !== 0) {
                    element.Voyages.forEach(value => {
                        if (!tempArray.includes(value.Voyage)) {
                            tempArray.push(value.Voyage)
                        }
                    })
                }
            })
            const temp = new Map()
            tempArray.forEach(viagem => {
                temp.set(viagem, [])
                response.DUMonthlyData.forEach(e => {
                    if (e.Voyages.lenght !== 0) {
                        let Bol = false
                        let dataVoyage = []

                        e.Voyages.forEach(value => {
                            if (value.Voyage === viagem) {
                                Bol = true
                                dataVoyage = value
                            }
                        })
                        // console.log(viagem,dataVoyage)
                        if (Bol) {
                            const tempPush = temp.get(viagem)
                            tempPush.push([dataVoyage.Bookings.Approved, dataVoyage.Bookings.Rejected, dataVoyage.BLs.Approved, dataVoyage.BLs.Rejected])
                            temp.set(viagem, tempPush)
                        } else {
                            const tempPush = temp.get(viagem)
                            tempPush.push([0, 0, 0, 0])
                            temp.set(viagem, tempPush)
                        }

                    } else {
                        const tempPush = temp.get(viagem)
                        tempPush.push([0, 0, 0, 0])
                        temp.set(viagem, tempPush)
                    }
                })
                setDataDesdobramento(newData)
                dynamicData(temp, newData, type)
            })
        })
    }

    const dynamicData = (temp, newData, type) => {
        const view = type ? type : 'Booking'
        if (temp.size === 0) return { label: [], datasets: [] }
        if (view === 'Booking') {
            newData.datasets = []
            Object.entries(Object.fromEntries(temp)).forEach(voyage => {
                const tempDataSet = [{
                    label: voyage[0], //rejected
                    data: voyage[1].map(tempValues => tempValues[1]),
                    backgroundColor: '#ff0000',
                    stack: voyage[0],
                },
                {
                    label: voyage[0], //approved
                    data: voyage[1].map(tempValues => tempValues[0]),
                    backgroundColor: '#33cc33',
                    stack: voyage[0],
                }]
                newData.datasets.push(...tempDataSet)
                // newData.labels = ['Approved', 'Rejected']
            })
            setDataDesdobramento(newData)

        } else {
            newData.datasets = []
            Object.entries(Object.fromEntries(temp)).forEach(voyage => {
                const tempDataSet = [{
                    label: voyage[0], //rejected
                    data: voyage[1].map(tempValues => tempValues[3]),
                    backgroundColor: '#ff0000',
                    stack: voyage[0],
                },
                {
                    label: voyage[0], //Approved
                    data: voyage[1].map(tempValues => tempValues[2]),
                    backgroundColor: '#33cc33',
                    stack: voyage[0],
                }]
                newData.datasets.push(...tempDataSet)
            })
            setDataDesdobramento(newData)
        }
        return newData
    }

    const newDataChartPie = (type) => {
        if (type == 'Booking') {
            return {
                labels: ['Approved', 'Waiting', 'Rejected'],
                datasets: [
                    {
                        data: [
                            filtersDashboard.Booking ? filtersDashboard.Booking.Approved : 0,
                            filtersDashboard.Booking ? filtersDashboard.Booking.Waiting : 0,
                            filtersDashboard.Booking ? filtersDashboard.Booking.Rejected : 0
                        ],
                        backgroundColor: ["#299C00", "#E2CC00", "#D40000"]
                    }
                ]
            }
        }
        if (type == 'BL') {
            return {
                labels: ['Approved', 'Waiting', 'Rejected'],
                datasets: [
                    {
                        data: [
                            filtersDashboard.BL ? filtersDashboard.BL.Approved : 0,
                            filtersDashboard.BL ? filtersDashboard.BL.Waiting : 0,
                            filtersDashboard.BL ? filtersDashboard.BL.Rejected : 0
                        ],
                        backgroundColor: ["#299C00", "#E2CC00", "#D40000"]
                    }
                ]
            }
        }
    }

    const clickPieChart = (type) => {
        if (type === 'Booking') {
            navigate("go/Bookings")
            ctx2.newTab("go/Bookings", 'Booking')
        }
        if (type === 'BL') {
            navigate("go/BLs")
            ctx2.newTab("go/BLs", "BL's")
        }
    }

    const cardsBooking = [
        { name: t("TotalBookings"), value: filtersDashboard.Booking ? filtersDashboard.Booking.Total : '0', icon: <FormatListBulletedIcon className='iconCardDashboard' />, color: '#3798C7' },
        { name: t("ApprovedBookings"), value: filtersDashboard.Booking ? filtersDashboard.Booking.Approved : '0', icon: <CheckIcon className='iconCardDashboard' />, color: '#299C00' },
        { name: t("RejectedBookings"), value: filtersDashboard.Booking ? filtersDashboard.Booking.Rejected : '0', icon: <CloseIcon className='iconCardDashboard' />, color: '#D40000' },
    ]

    const cardsBL = [
        { name: t("TotalBLs"), value: filtersDashboard.BL ? filtersDashboard.BL.Total : '0', icon: <FormatListBulletedIcon className='iconCardDashboard' />, color: '#3798C7' },
        { name: t("ApprovedBLs"), value: filtersDashboard.BL ? filtersDashboard.BL.Approved : '0', icon: <CheckIcon className='iconCardDashboard' />, color: '#299C00' },
        { name: t("RejectedBLs"), value: filtersDashboard.BL ? filtersDashboard.BL.Rejected : '0', icon: <CloseIcon className='iconCardDashboard' />, color: '#D40000' },
    ]

    const rangeDates = (e) => {
        setRangeDate(e)
        if (e !== null && e[0] !== null && e[1] !== null) {
            filtersMap.set('StartDate', toJSONLocal(e[0]))
            filtersMap.set('EndDate', toJSONLocal(e[1]))
            setFiltersMap(new Map(filtersMap))
            submitFilters(filtersMap)

        } else {
            ctx.toastMessages('error', '', t("SelectNewData"))
        }
    }

    const selectFilter = (key, value) => {
        filtersMap.set(key, value)
        setFiltersMap(new Map(filtersMap))
        // submitFilters(filtersMap)
    }

    const clearAllFilters = () => {
        filtersMap.set('Voyage', '')
        filtersMap.set('Trade', '')
        filtersMap.set('Account', '')
        filtersMap.set('Location', '')
        filtersMap.set('StartDate', toJSONLocal(arrayDate[0]))
        filtersMap.set('EndDate', toJSONLocal(arrayDate[1]))
        filtersMap.set('DateType', 'createdOn')

        setFiltersMap(new Map(filtersMap))
        submitFilters(filtersMap)
        ctx.toastMessages('success', '', t("FilterCleared"))
    }

    const submitFilters = (passFilter) => {
        ctx.setIsLoad(true)
        setAnchorEl(null)
        const tempFilter = passFilter ? passFilter : filtersMap
        const tempObj = [...tempFilter].filter(obj => obj[1] !== '').map(obj => {
            return {
                'entity': obj[0],
                'value': obj[1]
            }
        })
        bufferServiceFilters.post(tempObj).then((response) => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.message, '')

            }
            setFiltersDashboard(response)
            ctx.toastMessages('success', '', t("FilterApplied"))
            setIsLoaded(false)
            ctx.setIsLoad(false)
            setAnchorEl(null);
        })

    }

    const changeChartOcupation = (tempCheck, valuesOcupation) => {
        if (tempCheck === true) {
            ctx.toastMessages('success', '', t("CheckNewVoyages"))
        } else {
            ctx.toastMessages('success', '', t("HiddenVoyages"))
        }
    }

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const getCapacity = (value) => {
        const data = {
            labels: ['Full', 'Waiting', 'Not Full'],
            datasets: [
                {
                    data: [
                        value.UsedCapacityApproved,
                        value.UsedCapacityWaitingForApproval,
                        value.VesselCapacity - (value.UsedCapacityWaitingForApproval + value.UsedCapacityApproved) < 0 ?
                            '0' :
                            value.VesselCapacity - (value.UsedCapacityWaitingForApproval + value.UsedCapacityApproved)
                    ],
                    backgroundColor: [
                        "#299C00",
                        "#9BD2E8",
                        "#EBEDED",
                    ],
                }
            ]
        }
        return data
    }
    const getWeight = (value) => {
        const data = {
            labels: ['Full', 'Waiting', 'Not Full'],
            datasets: [
                {
                    data: [
                        value.VGMWeightApproved,
                        value.VGMWeightWaitingForApproval,
                        (value.VesselWeightCapacity || 0 - (value.VGMWeightWaitingForApproval + value.VGMWeightApproved)) < 0 ?
                            '0' :
                            value.VesselWeightCapacity || 0 - (value.VGMWeightWaitingForApproval + value.VGMWeightApproved)
                    ],
                    backgroundColor: [
                        "#299C00",
                        "#9BD2E8",
                        "#EBEDED",
                    ],
                }
            ]
        }
        return data
    }

    return (
        <>
            <M_Header
                element={
                    <>
                        <div className='divViewsDashboard' style={{ width: '100%' }}>
                            <div className='divInteriorWelcomeViewsDashboard' style={{ margin: '5px 20px', display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {t("Dashboard")}
                                    <M_Button
                                        label={<div style={{ fontSize: '1.2rem', color: 'var(--color-black)' }}>{t('Refresh')}</div>}
                                        icon={<i className="pi pi-refresh " style={{ fontSize: '1.2rem', color: ctx.primaryColor }}></i>}
                                        onClick={() => { submitFilters() }}
                                    />

                                </div>
                                <div className='divInteriorViewsDashboard'>
                                    <Calendar
                                        dateFormat="dd/mm/yy"
                                        value={rangeDate}
                                        onChange={(e) => rangeDates(e.target.value)}
                                        selectionMode="range"
                                        readOnlyInput
                                        showIcon
                                        showButtonBar
                                        className='calendarDashboard'
                                        style={{ width: '300px' }}
                                    />
                                    <M_Button
                                        none
                                        icon={<img src='/icons/svgsDaNet/filter.svg' alt='refresh' className="iconTable" />}
                                        label={<div style={{ fontSize: '1.2rem', color: 'var(--color-black)' }}>{t("Filters")}</div>}
                                        onClick={handleClick}
                                    />
                                    <Menu
                                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                        transformOrigin={{ vertical: "top", horizontal: "center" }}

                                        MenuListProps={{ disablePadding: true }}
                                        className="organizeMenuSearch"

                                        variant={'menu'}

                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        style={{ zIndex: '100', top: '15px' }}
                                    >
                                        <MenuItem
                                            disableRipple={true}
                                            style={{ backgroundColor: 'white' }}
                                        >
                                            <div className='divMenuDashboard'>
                                                <h4 className='h4FiltersDashboard'>
                                                    {t("DateType")}
                                                </h4>
                                                <div className='dropdownViewsDashboard' style={{ width: '300px' }}>
                                                    <M_Select
                                                        hasNone

                                                        options={[{ label: t('CreatedOn'), value: 'createdOn' }, { label: t('TransportDate'), value: 'transportDate' }]}
                                                        value={filtersMap.get('DateType')}
                                                        onClick={(value) => {
                                                            selectFilter("DateType", value.value)

                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </MenuItem>
                                        {typeUser ?
                                            <MenuItem
                                                disableRipple={true}
                                                style={{ backgroundColor: 'white' }}
                                            >
                                                <div className='divMenuDashboard'>
                                                    <h4 className='h4FiltersDashboard'>
                                                        {t("Clients")}
                                                    </h4>
                                                    <div className='dropdownViewsDashboard' style={{ width: '300px' }}>
                                                        <M_DrawerTableTextField
                                                            entity={'account'}
                                                            value={filtersMap.get("Account") ?
                                                                {
                                                                    AccountCode: filtersMap.get("Account")
                                                                } : null}
                                                            filterField={'AccountCode'}
                                                            labelFields={['AccountCode', 'AccountVat']}
                                                            onSubmitValue={(obj) => {
                                                                if (obj) {
                                                                    selectFilter("Account", obj.AccountCode)

                                                                } else {
                                                                    selectFilter("Account", '')
                                                                }
                                                            }}
                                                            fieldName={'AccountCode'}
                                                        />
                                                    </div>
                                                </div>
                                            </MenuItem>
                                            :
                                            ""
                                        }
                                        <MenuItem
                                            disableRipple={true}
                                            style={{ backgroundColor: 'white' }}
                                        >
                                            <div className='divMenuDashboard'>
                                                <h4 className='h4FiltersDashboard'>
                                                    {t("Voyages")}
                                                </h4>
                                                <div className='dropdownViewsDashboard' style={{ width: '300px' }}>
                                                    <M_Select
                                                        autocomplete
                                                        // label={t("FilterBound")}
                                                        value={filtersMap.get("Voyage") ? {
                                                            id: Math.random(),
                                                            value: filtersMap.get("Voyage"),
                                                            label: filtersMap.get("Voyage")
                                                        } : null}
                                                        options={dataVoyages?.map(value => {
                                                            return { value: value.VoyageNumber, label: value.VoyageNumber, id: Math.random(), }
                                                        })}
                                                        onChangeValue={(obj) => {
                                                            if (obj) {
                                                                selectFilter("Voyage", obj.value)
                                                            } else {
                                                                selectFilter("Voyage", '')
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </MenuItem>
                                        <MenuItem
                                            disableRipple={true}
                                            style={{ backgroundColor: 'white' }}
                                        >
                                            <div className='divMenuDashboard'>
                                                <h4 className='h4FiltersDashboard'>
                                                    {t("Bound")}
                                                </h4>
                                                <div className='dropdownViewsDashboard' style={{ width: '300px' }}>
                                                    <M_Select
                                                        autocomplete
                                                        // label={t("FilterVoyage")}
                                                        value={filtersMap.get("Trade") ? {
                                                            label: filtersMap.get("Trade") === 'i' ? "Import" : 'Export',
                                                            value: filtersMap.get("Trade")
                                                        } : null}
                                                        options={[{ label: 'Import', value: 'i' }, { label: 'Export', value: 'e' }]}
                                                        onChangeValue={(obj) => {
                                                            if (obj) {
                                                                selectFilter("Trade", obj.value)
                                                            } else {
                                                                selectFilter("Trade", '')
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </MenuItem>
                                        <MenuItem
                                            disableRipple={true}
                                            style={{ backgroundColor: 'white' }}
                                        >
                                            <div className='divMenuDashboard'>
                                                <h4 className='h4FiltersDashboard'>
                                                    {t("Destination")}
                                                </h4>
                                                <div className='dropdownViewsDashboard' style={{ width: '300px' }}>
                                                    <M_DrawerTableTextField
                                                        entity={'location'}
                                                        value={filtersMap.get("Location") ?
                                                            {
                                                                LocationName: filtersMap.get("Location")
                                                            } : null}
                                                        fieldName={'LocationName'}
                                                        filterField={'LocationName'}
                                                        labelFields={['LocationName']}
                                                        onSubmitValue={obj => {
                                                            if (obj) {
                                                                selectFilter("Location", obj.LocationName)
                                                            } else {
                                                                selectFilter("Location", '')
                                                            }
                                                        }}
                                                        FILTER={'LocationPortStatus eq true'}
                                                    />
                                                </div>
                                            </div>
                                        </MenuItem>
                                        <Divider />
                                        <MenuItem
                                            disableRipple={true}
                                            style={{ backgroundColor: 'white' }}
                                        >
                                            <div className='divbuttonDashboard'>
                                                <M_Button
                                                    hoverEffect
                                                    backgroundColor={'var(--color-red)'}
                                                    labelColor={'var(--color-white)'}
                                                    label={t("ClearFilters")}
                                                    onClick={() => clearAllFilters()}
                                                />
                                                <M_Button
                                                    hoverEffect
                                                    backgroundColor={'var(--color-green)'}
                                                    labelColor={'var(--color-white)'}
                                                    label={t("SubmitFilters")}
                                                    onClick={() => submitFilters()}
                                                />
                                            </div>
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </div>
                        </div>
                    </>
                }
            />
            <div className='divPrincipalDashboard'>
                <div className='divPrincipalPieChart'>
                    <div className='divChartCards'>
                        <div className='divPrincipalCards' >
                            {cardsBooking.map((value, index) => (
                                <M_Graph
                                    key={index}
                                    type={'data'}
                                    label={value.name}
                                    value={value.value}
                                    icon={value.icon}
                                    color={value.color}
                                />
                            ))}
                        </div>
                        <div className='divChartPie'>
                            <M_Graph
                                label={t('Bookings')}
                                type={'pie'}
                                onClick={(e) => { clickPieChart('Booking') }}
                                values={newDataChartPie('Booking')}
                            />
                        </div>
                    </div>
                    <div className='divChartCards'>
                        <div className='divChartPie'>
                            <M_Graph
                                label={t('BLs')}
                                type={'pie'}
                                onClick={(e) => { clickPieChart('BL') }}
                                values={newDataChartPie('BL')}
                            />
                        </div>
                        <div className='divPrincipalCards'>
                            {cardsBL.map((value, index) => (
                                <M_Graph
                                    key={index}
                                    type={'data'}
                                    label={value.name}
                                    value={value.value}
                                    icon={value.icon}
                                    color={value.color}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                {typeUser ?
                    <div>
                        <div className='divPrincipalTitleChartBar'>
                            <div className='divTitleCharts'>
                                {showWeight === 'Weight' ? t("VoyagesWeightCapacity") : t("VoyagesCapacity")}
                                {showWeight === 'Capacity' && <div className="tooltip"> ?
                                    <span className="tooltiptext">
                                        <ul>
                                            <li style={{ marginBottom: '10px' }}>
                                                {t("CapacityMeasured")}
                                            </li>

                                            <li>
                                                {t("CalculatedCapacityVoyage")}
                                            </li>
                                        </ul>
                                    </span>
                                </div>}
                            </div>
                            <div className='divTitleChartBarSelect'>
                                <div style={{ marginRight: '10px' }}>
                                    <M_CheckBox
                                        label={t("ShowFull")}
                                        checked={checkOcupation}
                                        onChange={() => {
                                            const tempCheck = !checkOcupation
                                            setCheckOcupation(tempCheck)
                                            changeChartOcupation(tempCheck, tempCheck)
                                        }}
                                    />
                                </div>
                                <div style={{ width: '200px' }} >
                                    <M_Select
                                        hasNone
                                        options={[{ label: 'Capacity', value: 'Capacity' }, { label: 'Weight', value: 'Weight' }]}
                                        value={showWeight}
                                        onChange={(e) => setShowWeight(e.target.value)}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className='divPrincipalchartOcupation'>
                            {filtersDashboard?.Voyages?.map((value, index) => {
                                if (!checkOcupation && value.VoyageStatusName === "Closed") {
                                    return (null)
                                } else {
                                    return (
                                        <span
                                            key={index}
                                            className='divChartPercentagem'
                                            style={filtersMap.get('Voyage') === value.VoyageNumber ? { boxShadow: '1px 2px 5px 1px #000000' } : {}}
                                            onClick={() => {
                                                if (value.VoyageNumber !== filtersMap.get('Voyage')) {
                                                    filtersMap.set('Voyage', value.VoyageNumber)
                                                } else {
                                                    filtersMap.set('Voyage', '')
                                                }
                                                submitFilters(filtersMap)
                                            }}
                                        >
                                            <M_Graph
                                                type={'doughnut'}
                                                label={`${t("Vessel")} ${value.NameVessel}`}
                                                subLabel={`${t("Voyage")} ${value.VoyageNumber}`}
                                                values={showWeight === 'Capacity' ? getCapacity(value) : getWeight(value)}
                                                doughnutInner={showWeight === 'Capacity' ?
                                                    `${(((value.UsedCapacityApproved) * 100) / value.VesselCapacity).toFixed(0)}%`
                                                    :
                                                    `${(((value.VGMWeightApproved) * 100) / value.VesselWeightCapacity).toFixed(0)}%`}
                                            />
                                        </span>
                                    )
                                }
                            })}
                        </div>
                    </div>
                    :
                    ""
                }

                <div className='divPrincipalTitleChartBar'>
                    <div className='divTitleCharts'>
                        {t("AnnualView")}
                    </div>
                    <div className='divTitleChartBarSelect' style={{ width: '200px' }}>
                        <M_Select
                            hasNone
                            value={selectAnnualView}
                            options={[{ label: 'Booking', value: 'Booking' }, { label: 'BL', value: 'BL' },]}
                            onChange={(e) => {
                                setSelectAnnualView(e.target.value)
                                columnChartData(e.target.value, true)
                            }}
                        />
                    </div>
                </div>
                <div className='divPrincipalChartBar'>
                    <M_Graph
                        type={'bar'}
                        values={dataDesdobramento}
                    />
                </div>
                <br /><br /><br /><br /><br />
            </div >

        </>
    )
}